module.exports = __webpack_public_path__ + "static/img/ct_qt_1.a9bd49ae.png";